import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import {
  ICON_HEIGHT_8,
  ICON_HEIGHT_16,
  IconNG,
  IconWithTooltip,
} from '../../Icon'
import { Skeleton } from '../../Skeleton'
import Text from '../../Text'

import * as styles from './Field.module.css'

import AsteriskIcon from '../../../icons/asterisk.svg'
import InformationIcon from '../../../icons/info.svg'

function Field({
  SymbolCounter,
  children,
  className,
  disabled,
  fieldInputClassName,
  info,
  infoTooltipPlacement,
  isLoading,
  label,
  labelClassName,
  labelTextProps,
  labelTooltipPlacement,
  maxLength,
  required,
  shouldAdaptToMobileScreen = false, // TODO remove this flag after make adaptive all form fields
  symbolCounterProps: {
    className: symbolCounterClassName = styles.symbolCounter,
    ...symbolCounterProps
  } = EMPTY_OBJECT,
  value,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const mods = { [styles.disabled]: disabled }

  const formFieldClassName = classNames(styles.Field, className, {
    [styles.mobile]: shouldAdaptToMobileScreen,
  })

  const preparedLabelClassName = classNames(styles.label, labelClassName, mods)

  const preparedFieldInputClassName = classNames(
    styles.fieldInput,
    fieldInputClassName
  )

  return (
    <div className={formFieldClassName}>
      {isLoading ? (
        <Skeleton className={styles.labelSkeleton} />
      ) : label ? (
        <div className={preparedLabelClassName}>
          <FloatingTooltip
            content={label}
            disabled={!overflow}
            placement={labelTooltipPlacement}
          >
            <Text {...labelTextProps} isSecondary ref={setContentOverflowRef}>
              {label}
            </Text>
          </FloatingTooltip>
          {required ? (
            <IconNG
              Icon={AsteriskIcon}
              className={styles.requiredIcon}
              size={ICON_HEIGHT_8}
            />
          ) : null}

          {info ? (
            <IconWithTooltip
              Icon={InformationIcon}
              className={styles.icon}
              size={ICON_HEIGHT_16}
              tooltip={info}
              tooltipPlacement={infoTooltipPlacement}
            />
          ) : null}
          {SymbolCounter ? (
            <SymbolCounter
              {...symbolCounterProps}
              className={symbolCounterClassName}
              maxLength={maxLength}
              value={value}
            />
          ) : null}
        </div>
      ) : null}
      <div className={preparedFieldInputClassName}>
        {isLoading ? <Skeleton className={styles.valueSkeleton} /> : children}
      </div>
    </div>
  )
}

export default Field
